import StockList from './StockList'
export {StockList}
export default StockList
